/**
 * The periods the dashboard's usage and sign-in panels offer — the two the API
 * accepts (`USAGE_WINDOWS` in the backend's `activity.validation.ts`).
 */
export const USAGE_PERIODS = [
  { value: '7', label: 'Last 7 days' },
  { value: '30', label: 'Last 30 days' },
] as const;

export type UsagePeriod = (typeof USAGE_PERIODS)[number]['value'];
